import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { environment, getRelianceCustomerUrl } from './environments/environment';
import { defineCustomElements } from '@ionic/pwa-elements/loader';
import { applyBootFirebaseConfig, captureGoogleRedirectResult } from './app/constants/prelogin-tokens.store';

/** Resolves the base URL the same way StockoneService.getUrl() does. */
function resolveBaseUrl(): string {
  const savedApi = window.localStorage.getItem('_api');
  const defaultApi = environment.reliance
    ? (getRelianceCustomerUrl() ?? 'https://shipsy-wms-be.ril.com/')
    : 'https://neo-backend.stockone.com/';
  return savedApi || defaultApi;
}

async function bootstrapApplication(): Promise<void> {
  if (environment.production) {
    enableProdMode();
  }
  captureGoogleRedirectResult();
  // No pre-login fetch: Firebase boots from the config cached by the last login's session call, or stays off until login.
  applyBootFirebaseConfig(resolveBaseUrl());

  // AppModule is dynamically imported so its @NgModule decorator (which reads
  // hasFirebaseConfig()) evaluates after the config is applied.
  const { AppModule } = await import('./app/app.module');
  await platformBrowserDynamic().bootstrapModule(AppModule)
    .catch(err => console.log(err));

  // Call the element loader after the platform has been bootstrapped
  defineCustomElements(window);
}

bootstrapApplication();
